import { NotificationManager } from 'react-notifications';
import { toApiResponseError } from '@/_api/normalize-error';
import type { ApiResponseError } from '@/_api/types';

const DEFAULT_DURATION_MS = 4000;

function isApiResponseError(error: unknown): error is ApiResponseError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    'title' in error &&
    'code' in error
  );
}

/** Skip session-expired errors — 401 handling already clears auth state. */
export function shouldSkipApiErrorSnack(error: unknown): boolean {
  const normalized = isApiResponseError(error)
    ? error
    : toApiResponseError(error);
  return normalized.code === '401';
}

/** Show a react-notifications error snack for a failed API request. */
export function showApiErrorSnack(
  error: unknown,
  fallbackMessage = 'Request failed',
): void {
  if (shouldSkipApiErrorSnack(error)) {
    return;
  }

  const normalized = isApiResponseError(error)
    ? error
    : toApiResponseError(error);

  NotificationManager.error(
    normalized.message || fallbackMessage,
    normalized.title || 'Error',
    DEFAULT_DURATION_MS,
  );
}
